import type { DocumentNode } from '@apollo/client';
import { datadogRum } from '@datadog/browser-rum'; // TODO: SAV-3878 build react-native support

export function getOperationName(document: DocumentNode) {
  const definition = document.definitions[0];

  if (definition === undefined || !('name' in definition)) {
    return undefined;
  }

  return definition.name?.value;
}

export function logGraphqlError(
  document: DocumentNode,
  error: { name: string; message: string },
  context: { userId: string | undefined; advisorId: string | null | undefined },
) {
  try {
    throw new Error(
      `${getOperationName(document)}
          error_name=${error.name} 
          error_message=${error.message}`,
    );
  } catch (thrown) {
    console.error(thrown);
    try {
      datadogRum.addError(thrown, {
        user_id: context.userId,
        logged_in_as_user_id: context.advisorId,
      });
    } catch (rumError) {
      // @datadog/browser-rum is web-only (SAV-3878) and throws on native. Logging here
      // surfaces genuine web-side RUM failures instead of silently swallowing them.
      console.error('[datadog-rum]', rumError);
    }
  }
}
